/** Chaves do React Query, centralizadas para invalidação consistente. */
export const queryKeys = {
  summary: ['me', 'summary'] as const,
  mySchedules: ['me', 'work-schedules'] as const,
  sessions: ['me', 'sessions'] as const,
  notificationsAll: ['me', 'notifications'] as const,
  notifications: (params: object) => ['me', 'notifications', 'list', params] as const,
  unreadCount: ['me', 'notifications', 'unread-count'] as const,
  notificationPreferences: ['me', 'notification-preferences'] as const,
  overtimeList: (params: object) => ['overtime', 'list', params] as const,
  reimbursementList: (params: object) => ['reimbursements', 'list', params] as const,
  requestDetail: (type: string, id: string) => ['request', type, id] as const,
  categories: (includeInactive: boolean) => ['catalog', 'categories', includeInactive] as const,
  departments: ['catalog', 'departments'] as const,
  costCenters: ['catalog', 'cost-centers'] as const,
  holidays: (year: number) => ['catalog', 'holidays', year] as const,
  settings: ['settings'] as const,
  employees: ['employees'] as const,
  users: (params: object) => ['users', 'list', params] as const,
  user: (id: string) => ['users', id] as const,
  employeeSchedules: (id: string) => ['employees', id, 'work-schedules'] as const,
  rhDashboard: (params: object) => ['rh', 'dashboard', params] as const,
  rhRequests: (params: object) => ['rh', 'requests', params] as const,
  rhPayments: (params: object) => ['rh', 'payments', params] as const,
  auditLogs: (params: object) => ['audit', params] as const,
  outbox: (params: object) => ['outbox', params] as const,
};
